import { Autocomplete, Chip, Stack, TextField } from "@mui/material"
import { If } from "lib/@components/switch"
import { BundleDemandPreview } from "./bundle-demand-preview"

/**
 * The auth bundle picker (FIQ-1926).
 *
 * Multi-select, and deliberately the same shape as the demand picker directly above it: an
 * override confers demands AND bundles together, so the two are one composition rather than a
 * choice between them. Anything else would make the admin save two overrides to express one
 * thing that was sold once.
 */
export function GrantBundleField({ bundles, selected, onSelect }) {
    return (
        <Stack spacing={1.5}>
            <Autocomplete
                multiple
                options={bundles ?? []}
                value={selected ?? []}
                onChange={change}
                getOptionLabel={labelOf}
                isOptionEqualToValue={sameBundle}
                renderInput={renderBundleInput}
                renderTags={renderTags}
                data-cy="grant-bundles"
            />
            <If value={(selected ?? []).length > 0}>
                <BundleDemandPreview bundles={selected} />
            </If>
        </Stack>
    )

    function change(_, chosen) {
        onSelect(chosen.map(idOf))
    }

    function idOf(bundle) {
        return bundle?.id
    }

    function labelOf(option) {
        return option?.name ?? ""
    }

    function sameBundle(option, value) {
        return option?.id === value?.id
    }

    function renderBundleInput(params) {
        return (
            <TextField
                {...params}
                label="Auth bundles"
                helperText="The override confers every configured demand in the bundles it names, as they stand at the time of each request"
            />
        )
    }

    function renderTags(value, getTagProps) {
        return value.map(toTag)

        function toTag(option, index) {
            return <Chip {...getTagProps({ index })} key={option.id} size="small" label={option.name} />
        }
    }
}
